import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { AfpService } from 'src/app/pages/services/afp.service';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { Afp } from 'src/app/shared/models/afps.interface';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-lista-afp',
  templateUrl: './lista-afp.component.html',
  styleUrls: ['./lista-afp.component.css']
})
export class ListaAfpComponent implements OnInit {

  @Input() afps_List: Afp[] = [];
  @Output() onDebounce: EventEmitter<boolean> = new EventEmitter();
  debouncer: Subject<boolean> = new Subject();

  update_afps: Afp = {
    id: 0,
    nombre: "",
    tasa: 0,
    cod_afp: 0,
  };

  displayedColumns: string[] = ['id', 'nombre', 'tasa', 'codigo', 'actions'];
  dataSource = new MatTableDataSource<Afp>(this.afps_List);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private alert: AlertHelper,
    private modalService: NgbModal,
    private afpsService: AfpService
  ) { }

  ngOnInit(): void {
    this.debouncer
      .pipe(debounceTime(500))
      .subscribe(valor => {
        this.onDebounce.emit(valor);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.afps_List != undefined) {
      if (!changes.afps_List.firstChange) {
        this.dataSource = new MatTableDataSource<Afp>(this.afps_List);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }
  }

  open(content: any, id: number) {
    this.update_afps.id = id
    this.afpsService.traerAfpPorId(id).subscribe(res => {
      this.update_afps.nombre = res.data.nombre;
      this.update_afps.tasa = res.data.tasa;
      this.update_afps.cod_afp = res.data.cod_afp;
    })

    this.limpiar_afps();
    this.modalService.open(content);

  }

  limpiar_afps() {
    this.update_afps.nombre = "";
    this.update_afps.tasa = 0;
  }

  Actualizar_Afps() {
    if (this.update_afps.nombre.trim().length == 0) {
      this.alert.error_small('Los campos no pueden estar vacios.')
      return
    }

    this.afpsService.actualizarAfp(this.update_afps).subscribe(res => {
      if (res.success == true) {
        this.alert.success_small(res.msg!)
        this.modalService.dismissAll();
        this.limpiar_afps();
        this.debouncer.next(true);
      } else {
        this.alert.error_small(res.msg!)
      }
    })


  }

  Eliminar_Afp(content: any, id: number) {
    Swal.fire({
      title: 'Eliminar?',
      text: "Se eliminara el AFP",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff0000',
      cancelButtonColor: '#6c736e',
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Eliminar'
    }).then((result) => {
      if (result.isConfirmed) {

        this.afpsService.eliminarAfp(id).subscribe(res => {
          if (res.success == true) {

            this.alert.success_small(res.msg!)
            this.modalService.dismissAll();
            this.debouncer.next(true);

          } else {
            this.alert.error_small(res.msg!)
          }
        })
      }
    })
  }
  //FITRAL
  applyFilter(event: Event) {
    //Funcion para filtar cualquier columna por el texto buscado
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }



}
